module.exports = __webpack_public_path__ + "img/008_FreeStyle Libre product shot icon.03c5429d.png";